import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://qgkqzwqvbxwxvlxqnwlr.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFna3F6d3F2Ynh3eHZseHFud2xyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDc0OTg5ODgsImV4cCI6MjAyMzA3NDk4OH0.Ry-1wm5_RHU_i7_fwaYmVYcooXn-_YQOGGkGwV11Ji8'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)